import { useMemo } from 'react'
import { DatesType } from './types'

type UseSelectedDays = {
  dates: DatesType
  enteredTo: Date | undefined
}

export const useSelectedDays = ({ dates, enteredTo }: UseSelectedDays) => {
  return useMemo(() => {
    const { from, to } = dates
    if (from && to) return [from, { from, to }]
    if (enteredTo && from) {
      if (enteredTo < from) {
        return [enteredTo, { from: enteredTo, to: from }]
      }
      if (enteredTo > from) {
        return [from, { from, to: enteredTo }]
      }
    }
  }, [dates, enteredTo])
}
